export default {
  methods: {
    // 删除前的二次确认
    beforeDelete() {
      const prom = this.$confirm('是否删除该条记录?', '提示', { type: 'warning' });
      prom.catch(() => this.$message.info('已取消'));
      return prom;
    },
    // 其他状态改变前的确认
    beforeChangeState(msg) {
      const prom = this.$confirm(msg, '提示', { type: 'warning' });
      prom.catch(() => this.$message.info('已取消'));
      return prom;
    }
  }
}
